import React from "react";
import { withTheme, withStyles } from "@material-ui/core";
import { compose } from "recompose";
import { withUserProfile } from "../../../../../../userProfile/userProfileContext";
import Map, {
  MapControls,
  MapConstant,
  Marker,
  Popup,
} from "../../../../../../lib/Map";
import { withAppConfig } from "../../../../../../appConfigContext";
import appConstants from "@appConstants";
import {
  TerminalMarker,
  SpottedTrailerMarker,
} from "../../../../../mapComponents/Markers";
import { SpottedTrailerPopupInfo } from "../../../../../mapComponents/Popups";
import { ToggleRenderer } from '@dataGrid/components/cellRenderer';

const styles = (theme) => ({
  moduleHeader: {    
    borderBottom: `1px solid ${theme.AppBGColor}`,   
    padding: '8px 10px 8px 24px',
    display: "flex",
    alignContent: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
  },
  headerText:{
    fontWeight: "bold",
    fontSize: theme.headerTextFontSize,
    color: theme.HeaderSelectedText,
    display: "flex",
    flexWrap: "wrap",
    alignContent: "center"
  },
  mapContainer: {
    borderLeft: `7px solid ${theme.AppBGColor}`,
    height: "100%",
  },
  toggleAnimationButton: {
    float: "left",
    cursor: "pointer",
    padding: "3px 0px",
    display: "flex",
    alignItems: "center",
  },
  toggleAnimationButtonDispatchMap: {
    float: "left",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      padding: "3px 8px",
    },
  },
  toggleAnimationButtonMenu: {
    justifyContent: "space-between",
  },
  toggleText: {
    display: "inline-block",
    fontSize: "12px",
    color: theme.iconColor,
  },
});
class TrailerMap extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTrailer: null,
    };
  }

  onTrailerIconClick = (selectedTrailer) => {
    this.props.trailerClickedOnMap(
      selectedTrailer ? [selectedTrailer?.data] : []
    );
    this.setState({
      selectedTrailer,
    });
  };

  onMapClick = (e) => {
    this.onTrailerIconClick(null);
  };

  getSpottedTrailerPopupData = (trailer) => {
    return {
      customerName: trailer.spottedDetails?.customerName,
      spottedAddress: trailer.spottedDetails?.spottedAddress,
      customerCode: trailer.spottedDetails?.customerCode,
      trailerNumber: trailer.trailerNumber,
      trailerScac: trailer.trailerScac,
      trailerName: trailer.trailerName,
      trailerStatus: trailer.trailerStatus,
      driverName: trailer.spottedDetails?.driverName,
      driverNumber: trailer.spottedDetails?.driverNumber,
      spottedSince: trailer.spottedDetails?.spottedSince,
    };
  };

  render() {
    const { theme, trailerList, configJSON, selectedAssets, classes, showTrailerMap, onShowMapToggleClick } = this.props;
    this.terminalLocation = this.props.userData.userProfile?.terminal?.location;
    const { selectedTrailer } = this.state;
    return (
      <div className={`${classes.mapContainer} subDiv`}>
        <div className={classes.moduleHeader}>
          <span className={classes.headerText}>Trailer Map</span>
          <span>
            <div
              className={`${classes.toggleAnimationButtonDispatchMap} glHeaderIcons ${classes.toggleAnimationButtonMenu} `}>
              <div className={classes.toggleText}>{`${showTrailerMap ? 'Hide' : 'Show'} Map`}</div>
              <ToggleRenderer
                value={showTrailerMap}
                onChange={() => onShowMapToggleClick(showTrailerMap)}
              />
            </div>
          </span>
        </div>
        <Map
          zoom={9}
          initialCenter={this.terminalLocation}
          center={this.terminalLocation}
          onClick={this.onMapClick}
          mapId={appConstants.mapIds.TRAILER_MAP}
          mapTheme={theme.themeName}
          mapConfig={configJSON?.maps}
        >
          <MapControls
            controlOptions={{
              zoomControl: {
                position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT,
              },
              satelliteViewControl: {
                position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT,
              },
              reCenterMapControl: {
                position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT,
              },
            }}
          />
          <Marker
            position={this.terminalLocation}
            animation
            anchorPoint={{ x: 20, y: 20 }}
            zIndex={1}
            forceUpdate={true}
            isActiveShipment
          >
            <TerminalMarker
              data={this.props.userData.userProfile.terminal}
              color={theme.terminalContentColor}
            />
          </Marker>
          {trailerList?.map((trailer) => {
            const isActive = selectedAssets?.includes(trailer.trailerId);
            return (
              trailer.latitude &&
              trailer.longitude && (
                <Marker
                  data={trailer}
                  position={{
                    lat: trailer.latitude,
                    lng: trailer.longitude,
                  }}
                  key={`${trailer.trailerId}_SpottedTrailerMarker`}
                  forceUpdate={true}
                  onClick={this.onTrailerIconClick}
                  isActiveShipment={isActive}
                  zIndex={isActive ? 1 : 0}
                >
                  <SpottedTrailerMarker
                    backgroundColor={isActive ? theme.white : theme.unassignPickupFillColor}
                    borderColor={isActive ? theme.unassignPickupFillColor : theme.markerStokeColor}
                  />
                </Marker>
              )
            );
          })}
          {selectedTrailer && selectedAssets.includes(selectedTrailer?.data?.trailerId) && (
            <Popup
              marker={selectedTrailer.marker}
              position={selectedTrailer.position}
              key={`${selectedTrailer.data.trailerId}_SpottedTrailerPopup`}
            >
              <SpottedTrailerPopupInfo
                trailerData={this.getSpottedTrailerPopupData(
                  selectedTrailer.data
                )}
                showTrailerScac={this.props.configJSON.showTrailerScac}
              />
            </Popup>
          )}
        </Map>
      </div>
    );
  }
}

export default compose(
  withTheme(),
  withUserProfile,
  withAppConfig,
  withStyles(styles)
)(TrailerMap);
